import { Component, Inject, OnInit } from '@angular/core';
import { PrintHistory, TargetDocument } from '../../model';
import { SharedService } from '../shared.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { groupBy, sortBy, reverse } from 'lodash';

@Component({
	selector: 'ft-printing-history',
	templateUrl: './printing-history.component.html',
	styleUrls: ['./printing-history.component.scss'],
})
export class PrintingHistoryComponent implements OnInit {
	printingHistory: PrintHistory[] = [];
	docsPrintingCounts: { count: number; doc: TargetDocument }[];

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private shared: SharedService
	) {}

	ngOnInit(): void {
		this.shared
			.getPrintHistory(this.data.targetDocuments, this.data.documentId)
			.subscribe(value => {
				this.printingHistory = reverse(sortBy(value, ['dateTime']));
				const docs = groupBy(value, 'targetDocument');
				this.docsPrintingCounts = this.data.targetDocuments.map(doc => {
					return {
						doc: doc,
						count: docs[doc]?.length,
					};
				});
			});
	}
}
